const defaultIsOptionEqualToValue = (a, b) => a === b;
const isDefaultOptionEqualToValue = (fn) => fn === defaultIsOptionEqualToValue;
export {
  defaultIsOptionEqualToValue,
  isDefaultOptionEqualToValue
};
//# sourceMappingURL=defaultIsOptionEqualToValue.js.map
